var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (true)?_c('div',{staticClass:"smoke-effect",attrs:{"mode":"currentLevel"}},_vm._l((_vm.items),function(item,idx){return _c('div',{key:idx,staticClass:"smoke-item",style:(_vm.itemStyle(item))})}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }